import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  signInWithEmailAndPassword,
  getAuth,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import './LoginForm.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/Logo.png';
import LoadingScreen from './loading';
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);
const googleProvider = new GoogleAuthProvider();

const LoginForm = ({ handleTabChange }) => {
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleLoginSubmit();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [loginForm]);

  const handleLoginChange = (e) => {
    const { id, value } = e.target;
    setLoginForm((prevState) => ({ ...prevState, [id]: value }));
    setError('');
  };

  const handleLoginSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    try {
      const credentials = await signInWithEmailAndPassword(auth, loginForm.email, loginForm.password);
      const user = credentials.user;

      if (!user.emailVerified) {
        setError('Correo no verificado. Por favor verifica tu correo.');
        setIsLoading(false);
        return;
      }

      localStorage.setItem('currentUserEmail', loginForm.email);
      localStorage.setItem('currentUserId', user.uid);

      const userDocRef = doc(db, 'usuarios', user.uid);
      const docSnap = await getDoc(userDocRef);

      if (docSnap.exists()) {
        await updateDoc(userDocRef, { lastConnection: new Date().toISOString() });
      }

      redirectToReservation();
    } catch {
      setError('Usuario o contraseña incorrectos.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userDocRef = doc(db, 'usuarios', user.uid);
      const docSnap = await getDoc(userDocRef);

      if (!docSnap.exists()) {
        await setDoc(userDocRef, {
          name: user.displayName || 'Usuario',
          email: user.email,
          role: 'user',
          photoURL: user.photoURL || '',
          lastConnection: new Date().toISOString()
        });
      } else {
        await updateDoc(userDocRef, { lastConnection: new Date().toISOString() });
      }

      localStorage.setItem('currentUserEmail', user.email);
      localStorage.setItem('currentUserId', user.uid);

      redirectToReservation();
    } catch (error) {
      console.error('Error en autenticación con Google:', error);
      setError('No se pudo iniciar sesión con Google.');
    } finally {
      setIsLoading(false);
    }
  };

  const redirectToReservation = () => {
    const reservation = localStorage.getItem('reservation');
    const url = localStorage.getItem('reservationUrl');

    if (reservation === "true" && url) {
      try {
        const pathOnly = new URL(url).pathname;
        navigate(pathOnly);
        localStorage.removeItem('reservation');
        localStorage.removeItem('reservationUrl');
      } catch {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };

  return (
    <div className="login-form-container">
      <form className="form-container-log" onSubmit={handleLoginSubmit}>
        <img src={logo} alt="logo" className="logo" />
        <p className="text-loggin">Tu espacio, Mi espacio</p>

        {error && (
          <div className="fondoError">
            <FontAwesomeIcon className="iconerror" icon={faTriangleExclamation} />
            <p className="error-message">{error}</p>
          </div>
        )}

        <div className="floating-label2">
          <input
            id="email"
            type="email"
            value={loginForm.email}
            onChange={handleLoginChange}
            required
            placeholder=""
          />
          <label htmlFor="email">Email</label>
        </div>

        <div className="floating-label2">
          <input
            id="password"
            type="password"
            value={loginForm.password}
            onChange={handleLoginChange}
            required
            placeholder=" "
          />
          <label htmlFor="password">Contraseña</label>
        </div>

        <div className="remember-password">
          <span className="clickable" onClick={() => handleTabChange('olvidasteContrasenia')}>
            ¿Olvidaste tu contraseña?
          </span>
        </div>

        <div className="buttonlog">
          <button type="button" className="btn" onClick={handleLoginSubmit} disabled={isLoading}>
            {isLoading ? 'Cargando...' : 'Iniciar Sesión'}
          </button>
        </div>

        <div className="buttonlog">
          <button type="button" className="btn-google google-btn" onClick={handleGoogleLogin} disabled={isLoading}>
            {isLoading ? 'Cargando...' : 'Iniciar sesión con Google'}
          </button>
        </div>
        {
          isLoading && <LoadingScreen />
        }

        <div className="info-message">
          ¿No tienes una cuenta?{' '}
          <span className="clickable" onClick={() => handleTabChange('register')}>
            Regístrate
          </span>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
